import { Injectable } from '@angular/core'
import { ApiService } from '../../../shared/absracts/api-service'
import { UserDataService } from '../../user-data/user-data.service'
import { MethodsService } from '../../methods/methods.service'
import { GlobalState } from '../../../app.state'
import { PiReportsProcessorService } from '../processors/pi-reports-processor.service'

@Injectable()
export class PiReportsService extends ApiService {

  constructor (protected _state: GlobalState, protected _user: UserDataService) {
    super(_state, _user)
  }

  async getMetadata (): Promise<PiExtendedReportMetadata[]> {
    const response = await this.get(`api/admin_api/reports/metadata`)
    return PiReportsProcessorService.processMetadata(response.data)
  }

  async getReport (type: string, options: GetReportArguments): Promise<StandardJson[]> {
    const queryString = MethodsService.objectToQueryString({ type, ...options })
    const response = await this.get(`api/admin_api/report?${queryString}`)
    return PiReportsProcessorService.process(response.data)
  }

}

